import React from 'react';
import LazyImage from '../components/LazyImage';
import '../styles/Insights.css';

const Insights = () => {
  return (
    <section id="insights" className="insights-section">
        <div className="container">
            <h2 className="insights-title">
                EXPLORING<br/>
                PHOTOGRAPHY INSIGHTS
            </h2>

            <div className="insights-grid">
                {/* Card 1 */}
                <div className="insight-card">
                    <div className="card-image-wrapper">
                        <LazyImage 
                          src={require('../assets/images/s3_1.jpg')} 
                          alt="Camera equipment"
                          className="card-image"
                        />
                    </div>
                    <h3 className="card-title">
                        MASTERING COMPOSITION THE KEY TO CAPTIVATING PHOTOGRAPHS
                    </h3>
                    <p className="card-desc">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur, vulputate in nibh eget, volutpat commodo nibh.
                    </p>
                    <a href="#" className="read-more-link">
                        READ MORE <span className="arrow-icon">→</span>
                    </a>
                </div>

                 {/* Card 2 */}
                 <div className="insight-card">
                    <div className="card-image-wrapper">
                        <LazyImage 
                          src={require('../assets/images/s3_2.jpg')} 
                          alt="Photography gear"
                          className="card-image"
                        />
                    </div>
                    <h3 className="card-title">
                        UNLOCKING CREATIVITY INSPIRING IDEAS FOR YOUR PHOTOGRAPHY
                    </h3>
                    <p className="card-desc">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur, vulputate in nibh eget, volutpat commodo nibh.
                    </p>
                    <a href="#" className="read-more-link">
                        READ MORE <span className="arrow-icon">→</span>
                    </a>
                </div>
            </div>
        </div>
    </section>
  );
};

export default Insights;
